<script setup>
import {defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
]);

const emits = defineEmits([
    "update:alteraContasAPagar",
]);

//==================================================================//
//================== Altera Contas a Pagar =========================//
//==================================================================//

const alteraContasAPagar = (update)=>{

    emits('update:alteraContasAPagar',update);

};

//==================================================================//
//==================== Contas a Pagar Headers ======================//
//==================================================================//

let contasAPagarHeaders = [
    { text: '',                              value: 'controles'},
    { text: 'N° da Conta a Pagar',           value: 'contaAPagarCodigo'},
    { text: 'Status',                        value: 'status'},
    { text: 'Forma de Pagamento',            value: 'forma'},
    { text: 'Tipo de Pagamento',             value: 'tipo'},
    { text: 'Evento de Pagamento',           value: 'evento'},
    { text: 'Descrição',                     value: 'descricao'},
    { text: 'Data Vencimento',               value: 'dataVencimento'},
    { text: 'Valor Original',                value: 'valorOriginal'},
    { text: 'Valor a Reservar',              value: 'valorParaReservar'},
    { text: 'Valor dos Descontos',           value: 'valorDesconto'},
    { text: 'Valor dos Pagamentos',          value: 'valorPagamento'},
    { text: 'Valor Reservado',               value: 'valorReservado'},
    { text: 'Valor a Pagar',                 value: 'valorParaPagar'},
    { text: 'Valor Pago',                    value: 'valorPago'},
    { text: 'Valor a Vincular',              value: 'valorParaVincular'},
    { text: 'Valor Vinculado',               value: 'valorVinculado'},
    { text: 'Liberado por',                  value: 'liberadorNome'},
    { text: 'Aprovado por',                  value: 'aprovadorNome'},
    { text: 'Reprovado por',                 value: 'reprovadorNome'},
    { text: 'Justificativa da Reprovação',   value: 'reprovadorJustificativa'},
    { text: '',                              value: 'espaco'},
]

//==================================================================//
//==================== Contas a Pagar Headers ======================//
//==================================================================//

const aoSelecionarTodasAsContasAPagar = ()=>{
    
    alteraContasAPagar({
        selecionado:!props?.dado?.selecionado
    });

};

</script>

<template>

    <div class="c-table__header">

        <div class="c-header__cell" v-for="contaAPagarHeader in contasAPagarHeaders"
            :key="contaAPagarHeader.value"
        >

            <div class="c-cell c-cell__checkbox"
                v-if="contaAPagarHeader.value == 'controles'"
            >

                <v-checkbox
                    class="c-checkbox"
                    hide-details
                    :disabled="props?.controlesDesativados"
                    :value="props?.dado?.selecionado"
                    @change="aoSelecionarTodasAsContasAPagar"
                ></v-checkbox>

            </div>

            <div class="c-cell c-cell__text"
                v-else
            >

                {{contaAPagarHeader.text}}

            </div>
            
        </div>

    </div>

</template>

<style scoped>

.c-table__header{
    display: contents;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-header__cell{
    align-content: center;
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #230bc1;
    color: #ffffff;
}

.c-checkbox{
    padding: 0px;
    margin: 0px;
}

.c-checkbox >>> .v-icon{
    font-size: 26px;
}

.c-checkbox >>> .mdi-checkbox-blank-outline::before{
    color: white;
}

.c-checkbox >>> .mdi-checkbox-marked::before{
    color: white;
}

.c-checkbox >>> .v-input--selection-controls__input{
    margin: 0px;
}

.c-checkbox >>> .v-input__control{
    flex-grow: 0;
    flex-wrap: nowrap;
    min-width: auto;
    width: auto;
}

</style>